var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1440px",
    height: "745px",
    viewBox: "0 0 1440 745",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "77.5740053%",
    y1: "43.8376683%",
    x2: "-44.4143352%",
    y2: "31.1969552%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(77, 20, 140, 1)",
    offset: "0.0220238746%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(77, 20, 140, 1)",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(77, 20, 140, 1)",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "11.-Home-page-&-top-of-the-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-111.774305, -123.865651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-Copy-3",
    transform: "translate(846.000000, 570.000000) rotate(169.000000) translate(-846.000000, -570.000000) translate(68.000000, 141.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1555.76216,275.72222 L1451.19883,813.653917 C1301.87464,890.887222 1116.75492,866.532912 991.58954,741.02802 C765.09929,513.923412 379.199587,534.835702 152.709337,761.940318 L0.0663097221,732.269519 L142.219011,0.957267143 L1555.76216,275.72222 Z",
    id: "path-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.774305,647.865651 C704.774305,890.532317 1184.77431,743.865651 1551.77431,207.865651",
    id: "Path-7",
    stroke: "#E2E7F3",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.accc9874c6cf7da6d94e1cd5e26d513c.svg";
export { ForwardRef as ReactComponent };